import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LangProvider } from "@/lib/LangContext";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Tracking from "@/pages/Tracking";
import MarketingQR from "@/pages/MarketingQR";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/book" element={<Booking />} />
        <Route path="/confirmation/:id" element={<Confirmation />} />
        <Route path="/track" element={<Tracking />} />
        <Route path="/track/:id" element={<Tracking />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/qr" element={<MarketingQR />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}
